export enum CardListSize {
  SMALL = 'small',
  MID = 'mid',
}

export enum CardListSelectColor {
  DEFAULT = 'default',
  PINK = 'pink',
}

export type CardListItemIconName =
  | 'ui-file'
  | 'ui-code-block'
  | 'ui-image'
  | 'ui-pen'
  | 'ui-video-file';
